import axios from "axios";
import { TransactionWithInstrumentAndAccount, Transaction } from "../types";
import getServiceEndpoint from "./ServiceEndpoint";
import { buildClientHeader } from "./buildHeader";

export const getTransactions = async (
  fundId: number,
  reportingPeriodId?: number
): Promise<TransactionWithInstrumentAndAccount[]> => {
  try {
    // TODO - add reporting period!
    const response = await axios.get(
      `${getServiceEndpoint()}/transactions?fundId=${fundId}${
        reportingPeriodId ? `&reportingPeriodId=${reportingPeriodId}` : ""
      }`,
      buildClientHeader()
    );
    if (response.status !== 200 || response.data === undefined) {
      console.log("Failed to retrieve transactions", response.statusText);
      return [];
    }
    return response.data ?? [];
  } catch (error) {
    console.error("Error getting transactions:", error);
  }

  return [];
};

/**
 * Updates a transaction with new values, including the isConfirmed status
 * @param transaction - The transaction object with updated values
 * @returns Promise resolving to the updated transaction or null if update failed
 */
export const updateTransaction = async (
  transaction: Transaction
): Promise<TransactionWithInstrumentAndAccount | null> => {
  try {
    const response = await axios.put(
      `${getServiceEndpoint()}/transactions`,
      JSON.stringify(transaction),
      buildClientHeader()
    );
    if (response.status !== 200 || response.data === undefined) {
      console.log("Failed to update transaction", response.statusText);
      return null;
    }
    return response.data;
  } catch (error) {
    console.error("Error updating transaction:", error);
    return null;
  }
};

/**
 * Deletes a transaction
 * @param transactionId - The ID of the transaction to delete
 * @param reportingPeriodId - The reporting period ID
 * @returns Promise resolving to true if deletion was successful, false otherwise
 */
export const deleteTransaction = async (
  transactionId: number,
  reportingPeriodId: number
): Promise<boolean> => {
  try {
    const response = await axios.delete(
      `${getServiceEndpoint()}/transactions?transactionId=${transactionId}&reportingPeriodId=${reportingPeriodId}`,
      buildClientHeader()
    );
    if (response.status === 200) {
      return true;
    }
    console.log("Failed to delete transaction", response.statusText);
    return false;
  } catch (error) {
    console.error("Error deleting transaction:", error);
    return false;
  }
};
